<template>
    <div class="view" :style="{ paddingTop: navbarheight }">
        <div class="content">
            <my-top title="消息详情" lefttext="返回列表" @leftclick="goBack"></my-top>
            <van-cell
                title-class="cell-title"
                title="通知名称"
                :value="details.title"
            />
            <van-cell
                title-class="cell-title"
                title="通知类型"
                :value="messageTypeMap[details.messageType]"
            />
            <van-cell
                title-class="cell-title"
                title="创建时间"
                :value="details.createTime"
            />
            <cell title="通知内容">
                <template slot="label">
                    <span>{{ details.content }}</span>
                </template>
            </cell>
        </div>
    </div>
</template>

<script>
import { Cell, Toast } from "vant";
import application from "@api/application";
// import { getMsgDetail } from "@api/a"

export default {
    name: "mattersDetail",
    components: {
        Toast,
        Cell,
    },
    data() {
        return {
            messageTypeMap: {
                1: "会议通知",
                2: "工作通知",
                3: "新闻通知",
                4: "车辆通知",
                5: "用餐通知",
                6: "抄送给我",
                7: "预警信息",
            },
            details: {}
        };
    },
    created() {
        if (this.$route.query.id) {
            this.getMsgDetail()
            // console.log('调用阅读接口')
        }
        if(this.active==='toRead'&&this.$route.query.id) {
            this.readMessage();
        }

    },
    computed: {
        // details() {
        //     const text = this.$route.query.detail
        //         ? JSON.parse(this.$route.query.detail)
        //         : {
        //               title: "",
        //               createTime: "",
        //               content: "",
        //               messageType: "",
        //           };
        //     return text;
        // },
        active() {
            return this.$route.query.active;
        },
    },
    methods: {
        getMsgDetail() {
            application.getMsgDetail(this.$route.query.id).then(res=>{
                 this.details = {...res.data, ...res.data.text}
            })
        },
        goBack() {
            this.$router.replace("/application/messages?key=1&active=" + this.$route.query.active)
        },
        readMessage() {
            const params = {
                ids: [this.$route.query.id],
            };
            application.messageRead(params).then((res) => {
                if (res && res.code == "200") {
                    Toast.success("查看成功");
                    let count = Number(
                        this.$store.getters["messageInfo/GET_TOREADCOUNT"] - 1
                    );
                    this.$store.commit(
                        "messageInfo/SET_TOREADCOUNT",
                        !isNaN(count) ? count : 0
                    );
                } else {
                    Toast(res.message ? res.message : "查看失败！");
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
